module.exports = __webpack_public_path__ + "static/media/picture-(288).abb58920.JPG";